import React from 'react';
export const SponsoredHeader: React.FC = () => {
  return <div className="w-full border-b border-navy/10 bg-cream" data-id="element-186">
      <div className="max-w-[680px] mx-auto px-5 sm:px-6 py-3 flex justify-center" data-id="element-187">
        <span className="text-[10px] sm:text-xs font-sans font-semibold tracking-widest text-navy/50 uppercase" data-id="element-188">
          Sponsored Content — Personal Development
        </span>
      </div>
    </div>;
};